module.exports = __webpack_public_path__ + "assets/img/elem5-ability2.26157258.gif";